const API_URL = process.env.REACT_APP_API_URL;

const ApiConstants = {
  BASE_URL: `${API_URL}/`,
  LOGIN_URL: 'login',
  REFRESH_ACCESS_TOKEN_URL: 'refresh-token',
  PROFILE: 'profile',
  RESET_PASSWORD: 'reset_password',
  SET_NEW_PASSWORD: 'set_new_password',
  GATEWAYS: 'gateways',
  UNITS: 'devices',
  REALTIME_DATA: 'data',
  DASHBOARD: 'dashboard',
  DATA_VIEW: 'data/aggregated',
  LAST_DATA: 'data/latest',
  USERS_MANAGEMENT: 'users',
  GROUPS: 'groups',
  GROUPS_MANAGEMENT: 'device_groups',
  LOGGERS_MANAGEMENT: 'loggers',
  ACTIVE_USERS: 'active_users',
  COMPANIES_MANAGEMENT: 'companies',
  STORES_MANAGEMENT: 'stores',
  DEPARTMENTS_MANAGEMENT: 'departments',
  LAST_SEQUENCE: 'last_sequence',
  GET_NEXT_SEQUENCE_VALUE: 'last_sequence/{:tableName}/next_sequence_value',
  UPDATE_USER_STATUS: 'update/user/status',
  RESEND_INVITATION_MAIL: 'resend/invitation',
  GET_DEVICE_CHANNELS: 'devices/{:deviceId}/channels',

  // GPS map
  GPS_RECEIVERS: 'gps/receivers',
  GPS_LOGGERS: 'gps/loggers',
  GPS_DEVICE_HISTORY: 'gps/{:deviceId}/history',

  // MISSING DATA SCREEN
  LOGGER_MISSING_DATA: 'loggers/missing-data',

  // Sensors map
  SENSORS_POSITION: 'sensors',

  RECEIVERS_MANAGEMENT: 'receivers',
  HISTORY_DATA_MANAGEMENT: 'history-data',
  HISTORY_COMBINED_DATA: 'history-combined-data',
  CSV_LOGGERS: 'csv-loggers',
  CSV_COMBINED_DATA: 'csv-combined-data',
  CSV_DATA_MANAGEMENT: 'csv-data',
  LOGGER_MISSING_TIME_RANGE: 'loggers/{:deviceId}/missing-time-range',

  DEVICE_ALARM_SETTINGS: 'device-alarm-settings',
  BACKEND_VERSION: 'version',

  // API Keys Management
  API_KEYS: 'api-keys',

  // Health Monitor Settings
  HEALTH_MONITOR: 'health-monitor',

  // Alarm Email Routing Settings
  ALARM_EMAIL_ROUTING: 'alarm-email-routing',
  ALARM_EMAIL_ROUTING_HOLIDAYS: 'alarm-email-routing/holidays',
  ALARM_EMAIL_ROUTING_MODE: 'alarm-email-routing/mode',

  // Test-mail send (テスト送信) for alarm email routing destinations
  NOTIFICATIONS: 'notifications',
};

export default ApiConstants;
